const accountsMe = {
  account_id: 2,
  account_name: 'shaked zohar',
  account_type_id: 1,
  avatar_url: 'https://avatars.githubusercontent.com/u/30412727?v=4',
  email: 'shaked.zrihen@gmail.com',
  current_provider_organization_id: 2,
  organizations: [
    {
      provider_organization_id: 2,
      provider_organization_name: 'ShakedZrihen',
      organization_avatar_url:
        'https://avatars.githubusercontent.com/u/30412727?v=4'
    },
    {
      provider_organization_id: 3,
      provider_organization_name: 'almog27',
      organization_avatar_url:
        'https://avatars.githubusercontent.com/u/1466549?v=4'
    }
  ]
};

export default accountsMe;
